/* Senna Video Kombinler: videolar sadece ekranda görünürken sessiz döngüde oynar; ses butonu tek videoyu açar. */
if (!customElements.get('senna-kombin-videos')) {
  customElements.define(
    'senna-kombin-videos',
    class SennaKombinVideos extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('.skv-card__media video'));
        if (!this.videos.length) return;

        this.videos.forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.removeAttribute('controls');
        });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.play(entry.target);
                else entry.target.pause();
              });
            },
            { threshold: 0.35 }
          );
          this.videos.forEach((video) => this.observer.observe(video));
        } else {
          this.videos.forEach((video) => this.play(video));
        }

        this.onSoundClick = this.onSoundClick.bind(this);
        this.addEventListener('click', this.onSoundClick);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onSoundClick) this.removeEventListener('click', this.onSoundClick);
      }

      play(video) {
        if (video.preload === 'none') video.preload = 'auto';
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => {});
      }

      videoFor(button) {
        const card = button.closest('.skv-card');
        return card ? card.querySelector('video') : null;
      }

      onSoundClick(event) {
        const button = event.target.closest('[data-skv-sound]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();
        const video = this.videoFor(button);
        if (!video) return;

        const turnOn = video.muted;

        // Aynı anda sadece bir videonun sesi açık olsun.
        this.querySelectorAll('[data-skv-sound]').forEach((other) => {
          const otherVideo = this.videoFor(other);
          if (otherVideo) otherVideo.muted = true;
          other.setAttribute('aria-pressed', 'false');
          other.setAttribute('aria-label', 'Sesi aç');
        });

        if (turnOn) {
          video.muted = false;
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', 'Sesi kapat');
          this.play(video);
        }
      }
    }
  );
}
